<div [id]="tourGuideIds.configBuilder.workflow.runnerDetail.id">
  <span mat-dialog-title>
    Select runner details
  </span>

  <div class="content-container">
    <div class="dialog-content" mat-dialog-content>
      <!-- runner details -->
      <form [formGroup]="detailsForm">
        <!-- type -->
        <div [id]="tourGuideIds.configBuilder.workflow.runnerDetail.id">
          <mat-form-field appearance="fill">
            <mat-label>{{typeLabel}}</mat-label>
            <mat-select formControlName="type" #dropdown [(ngModel)]="data.type" (selectionChange)="selectDropDown()">
              <mat-option *ngFor="let type of types" [value]="type">{{type}}</mat-option>
            </mat-select>

            <mat-error *ngIf="type && type.invalid">{{typeLabel}} is required!</mat-error>
          </mat-form-field>

          <!-- operating system -->
          <mat-form-field appearance="fill">
            <mat-label>{{osLabel}}</mat-label>
            <mat-select formControlName="os" #dropdown [(ngModel)]="data.os" (selectionChange)="selectDropDown()">
              <mat-option *ngFor="let system of systems" [value]="system">{{system}}</mat-option>
            </mat-select>

            <mat-error *ngIf="os && os.invalid">{{osLabel}} is required!</mat-error>
          </mat-form-field>

          <!-- lable -->
          <mat-form-field appearance="fill">
            <mat-label>{{labelLabel}}</mat-label>
            <mat-select formControlName="label" #dropdown [(ngModel)]="data.label">
              <mat-option *ngFor="let label of labels" [value]="label.name">{{label?.name}}</mat-option>
            </mat-select>

            <mat-error *ngIf="label && label.invalid">{{labelLabel}} is required!</mat-error>
          </mat-form-field>
        </div>
        <div class="action-btns" mat-dialog-actions>
          <button mat-button mat-dialog-close>Cancel</button>
          <button mat-button mat-dialog-close [id]="tourGuideIds.clickId" (click)="onSuccess()"
            [disabled]="!detailsForm.valid">Ok</button>
        </div>
      </form>
    </div>
  </div>
</div>